<template>
  <div class="content">
   
    <b-container fluid class="mt-4">
    
      <stats-card title="Farms" type="default" sub-title="All farms" icon="fas fa-warehouse">

        <template slot="actions">
            <a class="dropdown-item" href="javascript:void(0)" @click="showCreateModal = true">Create new</a>
        </template>

        <template slot="append">

          <base-alert>
            Last 10 farms created displayed here. Use the search bar below to fetch more.
          </base-alert>

          <div class="mt-4">
            <entity-picker v-if="farmData.length > 0"
                :canEdit="true"
                :canSelect="false"
                placeHolder="Start typing something..."
                apiEndpoint="getFarms"
                :selected="farmData"
                :filters="tableFilters"
                :key="farmPicker"
                editPath="/farms/"
                :tableOptions="tableOptions"
                :cursorData="cursorData"
                rootProp="farms"
                :tableColumns="tableColumns"
                :canExport="true"
            >
            </entity-picker>
          </div>
        </template>
      </stats-card>
    </b-container>

    <modal :show.sync="showCreateModal">
        <h6 slot="header" class="modal-title">Create Farm</h6>

        <entity-picker
            :key="orgPicker"
            :canEdit="false"
            :multiple="false"
            :canSelect="true"
            placeHolder="Select this farm's parent org"
            apiEndpoint="getOrgs"
            rootProp="organisations"
            @onSelect="onFarmCreateOrgSelect"
        >
        </entity-picker>

        <div v-if="newFarm.organisationId != null">
            <base-input label="Farm name:" v-model="newFarm.name"></base-input>
            <base-input label="Contact email:" v-model="newFarm.email"></base-input>
            <div class="form-group">
                <label class="form-control-label">Timezone:</label>
                <b-form-select v-model="newFarm.timezone" :options="timezones"></b-form-select>
            </div>
        </div>

        <template slot="footer">
            <base-button type="blank" @click="showCreateModal = false">Cancel</base-button>
            <base-button :disabled="newFarm.organisationId == null" type="success" @click="createNewFarm">Create Farm</base-button>
        </template>
    </modal>
  </div>
</template>

<script>
import api from '@/api'
import { tableColumns, tableFilters, tableOptions } from '@/config/FarmTable'
import { FarmModel } from '@/models/farm/farm'
import { timezones } from '@/config/Time'

export default {
  components: {
  },
  data() {
    return {
      showCreateModal: false,
      newFarm: new FarmModel(),
      farmData: [],
      tableFilters: tableFilters,
      tableColumns: tableColumns,
      tableOptions: tableOptions,
      cursorData: null,
      timezones: timezones
    }
  },
  created: async function() {
    this.$emit('loading', true);
    const results = await api.getFarms({
      sort: this.tableOptions['default-sort'].prop,
      direction: this.tableOptions['default-sort'].order == 'ascending' ? 'asc' : 'desc',
      limit: this.tableOptions.limit
    })
    this.$emit('loading', false);
    this.farmData = results.farms;
    this.cursorData = results.cursor
  },
  methods: {
    onFarmCreateOrgSelect(farmId) {
        this.newFarm.organisationId = farmId[0].id || null
    },
    createNewFarm: async function() {

        this.showCreateModal = false
        this.$emit('loading', true);

        console.log(this.newFarm.exportToCreate())

        const createFarm = await api.createFarm(this.newFarm.exportToCreate());

        // const createGroup = await api.createGroup({
        //     name: "Default orchard",
        //     farmId: createFarm.id,
        //     location: ''
        // });
        
        this.$emit('loading', false);
        this.$emit('onApiResult', 'Farm created, redirecting you to it...');
        this.$router.push(`/farms/${createFarm.id}?created`);
      }
  }
};
</script>
